import api from '@/api/index.js'

const account_purchases = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_ACCOUNT_PURCHASES_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_PURCHASES: (state, response) => {
      state.data = response
      state.loading = false;
    },
    SET_ACCOUNT_PURCHASES_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    GetAccountPurchases({commit}, id) {
      commit('SET_ACCOUNT_PURCHASES_LOADING', true)
      return api.get(`accounts/${id}/purchases?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_PURCHASES', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_PURCHASES_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_purchases
